<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Sort Order Helplist
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card>
          <!-- <v-card-title>
            <div class="headline">Sort Orders List</div>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title> -->
          <v-card-text>
            <!-- <v-data-table v-model="selected" :headers="headers" :items="SortOrderList" :search="search" :footer-props="{'items-per-page-options': itemsPerPage }" v-bind:options.sync="pagination" item-key="text" :loading="loading" :no-data-text="noDataText" :custom-filter="customSearch">
              <template v-slot:item="row">
                <tr :active="row.selected" @click="doSelectProp(row.item)" :key="row.item.text">
                  <td class="text-xs-left">{{row.item.text}}</td>
                  <td class="text-xs-left"><br><v-checkbox :input-value="row.item.subTotal" @click.stop="doSubTotal(row.item)" primary hide-detail></v-checkbox></td>
                  <td class="text-xs-left"><br><v-checkbox :input-value="row.item.pageBreak" @click.stop="doPageBreak(row.item)" primary hide-detail></v-checkbox></td>
                </tr>
              </template>
            </v-data-table> -->
            <v-data-table
              :headers="headers"
              :items="SortOrderList"
              :loading="loading"
              :custom-filter="customSearch"
              :no-data-text="noDataText"
              item-key="text"
              v-bind:search="search"
              v-model="selected"
              >
              <template v-slot:item="row">
                <tr :active="row.selected" @click="doSelectProp(row.item)" :key="row.item.text">
                  <td class="text-xs-left">{{row.item.text}}</td>
                  <td class="text-xs-left"><br><v-checkbox :input-value="row.item.subTotal" @click.stop="doSubTotal(row.item)" primary hide-detail></v-checkbox></td>
                  <td class="text-xs-left"><br><v-checkbox :input-value="row.item.pageBreak" @click.stop="doPageBreak(row.item)" primary hide-detail></v-checkbox></td>
                </tr>
              </template>
              </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="doClose">Cancel</v-btn>
            <v-btn color="primary" text @click.native="doSelect">Select</v-btn>
          </v-card-actions>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      headers: [
        { text: 'Sort Order', value: 'sortOrder', sortable: false },
        { text: 'Sub Total', value: 'subTotal', sortable: false },
        { text: 'Page Break', value: 'pageBreak', sortable: false }
      ],
      SortOrderList: [
        { id: 0, text: 'Agent', value: 'acctNo1', subTotal: false, pageBreak: false },
        { id: 1, text: 'Branch', value: 'branch', subTotal: false, pageBreak: false },
        { id: 2, text: 'Department', value: 'dept', subTotal: false, pageBreak: false },
        { id: 3, text: 'Direct / RI Inwards', value: 'dri', subTotal: false, pageBreak: false },
        { id: 4, text: 'Fund', value: 'fund', subTotal: false, pageBreak: false },
        { id: 5, text: 'Policy Type', value: 'polType', subTotal: false, pageBreak: false },
        { id: 6, text: 'Underwriting Year', value: 'uwYr', subTotal: false, pageBreak: false },
        { id: 7, text: 'Transaction Type', value: 'tranType', subTotal: false, pageBreak: false }
      ],
      selected: [],
      errMsg: 'Maximum 6 sort orders can be selected.',
      errMsg2: 'Maximum 3 page breaks can be selected.'
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    doInit() {
      this.selected = []
      if (this.sortOrderList.length > 0) {
        this.sortOrderList.map(sortOrder => {
          const index = sortOrder.id
          this.SortOrderList[index] = sortOrder
          this.selected.push(sortOrder)
        })
      }
    },
    doSelectProp(sortOrder) {
      const index = this.selected.indexOf(sortOrder)
      if (index === -1) {
        // not selected, select this row
        if (this.selected.length < 6) {
          // if (this.selected.length < 2) {
          //   sortOrder.pageBreak = true
          // }
          this.selected.push(sortOrder)
        } else {
          this.$toast.error(this.errMsg)
        }
      } else {
        // selected, initialize the row, unselect this row
        const id = this.selected[index].id
        this.SortOrderList[id].subTotal = false
        this.SortOrderList[id].pageBreak = false
        this.selected.splice(index, 1)
      }
    },
    doSubTotal(data) {
      this.SortOrderList.map((sortOrder) => {
        if (sortOrder.id === data.id) {
          sortOrder.subTotal = !sortOrder.subTotal
          // auto select the field if checked
          const index = this.selected.indexOf(sortOrder)
          if (index === -1) {
            if (this.selected.length < 6) {
              this.selected.push(sortOrder)
            } else {
              this.$toast.error(this.errMsg)
            }
          }
        }
      })
    },
    doPageBreak(data) {
      this.SortOrderList.map((sortOrder) => {
        if (sortOrder.id === data.id) {
          sortOrder.pageBreak = !sortOrder.pageBreak
          // auto select the field if checked
          const index = this.selected.indexOf(sortOrder)
          if (index === -1) {
            if (this.selected.length < 3) {
              this.selected.push(sortOrder)
            } else {
              this.$toast.error(this.errMsg2)
            }
          }
        }
      })
    },
    doSelect() {
      // if (this.selected !== undefined) {
      //   // if pagebreak for first two selected field is unchecked, default to checked
      //   if (this.selected[0] !== undefined) {
      //     if (!this.selected[0].pageBreak) {
      //       this.selected[0].pageBreak = true
      //     }
      //   }
      //   if (this.selected[1] !== undefined) {
      //     if (!this.selected[1].pageBreak) {
      //       this.selected[1].pageBreak = true
      //     }
      //   }
      // }
      this.$emit('doSortOrderList', this.selected)
    },
    doClose() {
      this.$emit('close')
    }
  },
  computed: {
    sortOrderList() {
      return this.selectedList
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ],
  props: {
    selectedList: Array
  }
}
</script>

<style>
</style>
